import React, { useState, useEffect } from "react";

import Layout from "../layout/Layout";

import Loading from "../ui/Loading";

import "./LoadingPage.css";

const LoadingPage = () => {

  const [waited, setWaited] = useState(false);

  useEffect(() => {

    const timeout = setTimeout(() => {
      setWaited(true);
    }, 10*1000);

    return () => {
      clearTimeout(timeout);
    }
  }, []);

  const onReloadClick = evt => {
    evt.preventDefault();
    window.location.reload();
  }

  return (
    <Layout>
      <div className="LoadingPage">
        <header>
          <Loading /> <strong className="-loading">Loading</strong>
        </header>
        {waited && (
          <div className="container">
            <hr/>
            <strong>
              This page is taking a lot longer than usual to load. Perhaps your
              internet connection is disconneced?
            </strong>
            <p>
              <a href={window.location.href} onClick={onReloadClick}>
                Click here to try to reload this page.
              </a>
            </p>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default LoadingPage;